import { COLORS } from "@/app/common/consts/colors";
import React from "react";
import type { IconProps } from "./type";

const WarningIcon = ({ color = "lightblack" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M16.0002 21.3333V17.3333M16.0002 13.3333V13.32M14.8347 4.76464L3.76736 24.6858C3.27364 25.5745 3.91626 26.6667 4.93291 26.6667H27.0675C28.0842 26.6667 28.7268 25.5745 28.2331 24.6858L17.1658 4.76464C16.6578 3.85022 15.3427 3.85022 14.8347 4.76464Z"
        stroke={COLORS[color]}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default WarningIcon;
